import {
  Flex,
  Heading,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  Text,
  useColorMode,
  useMediaQuery,
} from '@chakra-ui/react'
import React from 'react'
import logo from './logo.png'

import {
  FaPiggyBank,
  FaHistory,
  FaQuestionCircle,
  FaUserAlt,
} from 'react-icons/fa'
import { MdSettings } from 'react-icons/md'
import { FiLogOut } from 'react-icons/fi'
import { BiStats } from 'react-icons/bi'
import { GoChevronDown } from 'react-icons/go'
import { GiPayMoney } from 'react-icons/gi'
import { GiReceiveMoney } from 'react-icons/gi'
import { modalState, userState } from './store'
import { useRecoilState, useSetRecoilState } from 'recoil'
import AnimatedBalance from './AnimatedBalance'

export default function Header() {
  const { colorMode } = useColorMode()
  const [isSmallerThan576] = useMediaQuery('(max-width: 575px)')

  const [user, setUser] = useRecoilState(userState)
  const setModal = useSetRecoilState(modalState)

  function logout() {
    localStorage.removeItem('token')
    setUser({
      username: null,
      balance: null,
      currentBet: null,
      state: 'IDLE',
      isLoggedIn: false,
      address: null,
      tag: null,
    })
  }

  return (
    <>
      <Flex
        as="nav"
        px="4"
        mx="-2"
        bg={colorMode === 'dark' ? 'gray.700' : 'gray.100'}
        h="100%"
        alignItems="center"
      >
        <Flex alignItems="baseline">
          <Link>
            <Heading as="h1" size="md" mr="3">
              <Image
                boxSize="23px"
                mr="1"
                display="inline"
                objectFit="cover"
                src={logo}
              />
              {isSmallerThan576 ? 'XC' : 'XRPBust'}
            </Heading>
          </Link>
        </Flex>
        <Spacer />
        <Flex alignItems="center">
          {!user.isLoggedIn ? (
            <>
              {' '}
              <Link
                mx="3"
                onClick={() => {
                  setModal('register')
                }}
              >
                Register
              </Link>
              <Link
                onClick={() => {
                  setModal('login')
                }}
              >
                Login
              </Link>
            </>
          ) : (
            <>
              {' '}
              <Text as="span">
                XRP: <AnimatedBalance num={user.balance} />
              </Text>
              <Menu>
                <MenuButton as={Link} ml="3">
                  <FaUserAlt style={{ display: 'inline' }} />
                  {!isSmallerThan576 && (
                    <Text mx="1" as="span">
                      {user.username}
                    </Text>
                  )}
                  <GoChevronDown style={{ display: 'inline' }} />
                </MenuButton>
                <MenuList>
                  <MenuItem
                    onClick={() => {
                      setModal('deposit')
                    }}
                  >
                    <GiPayMoney /> <Text ml="2">Deposit</Text>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setModal('withdraw')
                    }}
                  >
                    <FaPiggyBank /> <Text ml="2">Withdraw</Text>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setModal('affiliate')
                    }}
                  >
                    <GiReceiveMoney /> <Text ml="2">Affiliate</Text>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setModal(`user ${user.username}`)
                    }}
                  >
                    <BiStats /> <Text ml="2">Bets</Text>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setModal('transactions')
                    }}
                  >
                    <FaHistory /> <Text ml="2">Transactions</Text>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setModal('help')
                    }}
                  >
                    <FaQuestionCircle /> <Text ml="2">Help</Text>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setModal('settings')
                    }}
                  >
                    <MdSettings /> <Text ml="2">Settings</Text>
                  </MenuItem>
                  {/* <MenuItem
                    onClick={() => {
                      setModal('support')
                    }}
                  >
                    <BiSupport /> <Text ml="2">Support</Text>
                  </MenuItem> */}
                  <MenuItem onClick={logout}>
                    <FiLogOut /> <Text ml="2">Logout</Text>
                  </MenuItem>
                </MenuList>
              </Menu>
            </>
          )}
        </Flex>
      </Flex>
    </>
  )
}
